// Auto-generated - do not edit manually
export const VERSION = "1.2.0";
export const DEFAULT_AGENT = `replane-js-react/${VERSION}`;
